import {
  ElementController,
  getData,
  getWindowWidth,
  parseHTML,
} from 'js-common';

const VIDEO_SMALL_THRESHOLD = 800;

/**
 * Controller for Intro area.
 *
 * @extends {ElementController}
 */
export default class Intro extends ElementController {
  static id = 'Intro';

  load() {
    // Has video, load the relevant size
    const videoEl = this.getSingleNode('video-root');
    if (videoEl) {
      const dataSrc =
        getWindowWidth() <= VIDEO_SMALL_THRESHOLD
          ? 'video-small'
          : 'video-large';
      const source = parseHTML(
        `<source type="video/mp4" src="${getData(videoEl, dataSrc)}">`,
      );
      videoEl.appendChild(source);

      // Only autoplay video if user not has reduced-motion turned on.
      const hasReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      );
      if (!hasReducedMotion.matches) {
        videoEl.setAttribute('autoplay', true);
      }
    }
  }
}
